import { render, staticRenderFns } from "./_OrganizationMismatchPopup.vue?vue&type=template&id=560e1d3c"
import script from "./_OrganizationMismatchPopup.vue?vue&type=script&lang=ts"
export * from "./_OrganizationMismatchPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports